module.exports = __webpack_public_path__ + "images/1b6a4aa5857772f6de0d0ab30aa64dcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/react/images/uerm/YAUR-380-300-31-L.jpg
// module id = 782
// module chunks = 0